import React, { useCallback, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  TextField,
  TablePagination,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  fetchGroupService,
  searchGroupsService,
} from "../../services/groupService";

const columns = [
  { id: "slNo", label: "SL.NO" },
  { id: "groupName", label: "GROUP NAME" },
  { id: "groupCode", label: "GROUP CODE" },
  { id: "groupLeaderNumber", label: "GROUP LEADER NUMBER" },
  { id: "agent", label: "AGENT" },
  { id: "collectionDay", label: "COLLECTION DAY" },
  { id: "totalLoanAmount", label: "TOTAL LOAN AMOUNT" },
  { id: "disbursedAmount", label: "DISBURSED AMOUNT" },
  { id: "totalMembers", label: "TOTAL MEMBERS" },
];

const GroupTable = () => {
  const navigate = useNavigate();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [groupLoans, setGroupLoans] = useState();
  const [totalGroups, setTotalGroups] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  // When rendering, you can format dates as:
  // const formattedDate = moment(row.startDate).format("DD-MM-YYYY");

  const fetchData = async () => {
    // Fetch loan data from API (pagination and search term passed)
    const response = searchQuery
      ? await searchGroupsService(page, rowsPerPage, searchQuery)
      : await fetchGroupService(page, rowsPerPage);
    console.log("response", response);
    setGroupLoans(response?.groups);
    setTotalGroups(response?.totalGroups);
    // setTotalLoanCount(collections.totalCollectedLoans); // Update total loan count for pagination
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, searchQuery]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleSearchChange = useCallback((event) => {
    const query = event.target.value;
    setSearchQuery(query);

    // Reset to the first page when starting a new search
    setPage(0);
  }, []);

  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            m: 2,
          }}
        >
          <Box sx={{ width: "50%" }}>
            <Typography variant="h6" gutterBottom>
              Search Group
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Search by name, code or phone number"
              onChange={handleSearchChange}
              value={searchQuery}
            />
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              sx={{
                py: 0.5,
                textTransform: "capitalize",
                fontSize: "16px",
                borderRadius: "8px",
              }}
              onClick={() => navigate("/group/create-group")}
            >
              Create Group
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              sx={{
                py: 0.5,
                textTransform: "capitalize",
                fontSize: "16px",
                borderRadius: "8px",
              }}
              onClick={() => navigate("/group/group-pigmy-collection")}
            >
              Group Pigmy Collection
            </Button>
            <Button
              variant="contained"
              size="small"
              sx={{
                py: 0.5,
                ml: 1,
                textTransform: "capitalize",
                fontSize: "16px",
                borderRadius: "8px",
              }}
              onClick={() => navigate("/group/group-collection")}
            >
              Group Collection
            </Button>
          </Box>

          {/* <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            // value={searchTerm}
            // onChange={handleSearchChange}
            sx={{ py: 0.5, backgroundColor: "#fff", borderRadius: 8 }}
          /> */}
        </Box>

        <Table stickyHeader aria-label="group table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align="left"
                  style={{
                    minWidth: column.minWidth,
                    color: "#5252ff",
                    backgroundColor: "#fff",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {groupLoans?.map((row, index) => (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={row._id || index}
              >
                <TableCell
                  align="center"
                  key={`${row._id}-slNo`}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {index + 1 + page * rowsPerPage}
                </TableCell>
                <TableCell
                  align="left"
                  key={`${row._id}-loanCode`}
                  onClick={() =>
                    navigate(`/group/view-group-details/${row._id}`)
                  }
                  sx={{
                    color: "#5252ff",
                    cursor: "pointer", // Change cursor to hand icon
                    "&:hover": {
                      textDecoration: "underline", // Optional: Add underline on hover
                    },
                  }}
                >
                  {row?.groupName}
                </TableCell>

                <TableCell
                  align="left"
                  key={`${row._id}-loanCode`}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {row?.groupCode}
                </TableCell>
                <TableCell
                  align="left"
                  key={`${row._id}-loanCode`}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {row?.groupLeaderPhoneNumber}
                </TableCell>
                <TableCell
                  align="left"
                  key={`${row._id}-loanAmount`}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {row?.agent?.userName}
                </TableCell>
                <TableCell
                  align="left"
                  key={`${row._id}-interest`}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {row?.collectionDay}
                </TableCell>
                <TableCell
                  align="left"
                  key={`${row._id}-interest`}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {row?.loanAmount}
                </TableCell>
                {/* <TableCell align="left" key={`${row._id}-startDate`}>
                    {moment(row?.startDate).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell align="left" key={`${row._id}-endDate`}>
                    {moment(row?.endDate).format("DD-MM-YYYY")}
                  </TableCell> */}
                {/* <TableCell align="left" key={`${row._id}-status`}>
                    {row?.status}
                  </TableCell> */}
                <TableCell
                  align="left"
                  key={`${row._id}-status`}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {row?.disbursedAmount}
                </TableCell>

                <TableCell
                  align="left"
                  key={`${row._id}-status`}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {row?.users.length}
                </TableCell>
                <TableCell
                  align="left"
                  key={row._id}
                  sx={{ padding: "5px", margin: "0px" }}
                >
                  {" "}
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={row?.users.length > 0}
                    size="small"
                    onClick={() => navigate(`/group/update-group/${row._id}`)}
                    sx={{ mr: 1, textTransform: "capitalize" }}
                  >
                    Add Members
                  </Button>
                </TableCell>
                {/* Add more TableCell components as needed for other fields */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalGroups}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ color: "#000" }}
        />
      </TableContainer>
    </>
  );
};

export default GroupTable;
